import React from 'react';
import styles from '../Operations.module.css';

interface SO03Component extends React.FC {
  title?: string;
}

/**
 * SOCIRATING - SOCI - Average Review Rating
 * KPI information component
 */
const SO03: SO03Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Shows how your store ranks among Google, Facebook and Yelp.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        In the SOCi platform, you can view deeper metrics into your reviews.
        <br /><br /> You can see important comments from your customers. 
        <br /><br />
        You can sort by sentiment (positive, neutral and negative) to answer reviews quickly.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Maintain a star rating between 4.5-4.7 stars.<br/>
        Answer all reviews and engagements &lt; 24 hours.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Sign-up and Questions:
        <ol>
          <li>
            Sign-up at no charge for the platform, visit{' '}
            <a
              href="https://www.soci.ai/acehardware/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}>
              www.soci.ai/acehardware/
            </a>
          </li>
          <li>Questions? Email: support@meetsoci.com</li>
        </ol>
      </div>
    </div>
  );
};

SO03.title = 'SOCi - Average Review Rating';
export default SO03;

